import { AlphabeticalOffIcon } from './AlphabeticalOffIcon';

/**
 * author: Michael Richins
 * id 5C6F0A6B-362A-4EBF-9E0C-57E7405429AE
 * name alphabetical-off
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alphabetical-off.svg
 * tags
 * - Alpha / Numeric 
 */
export const AbcOffIcon = AlphabeticalOffIcon;
export default AbcOffIcon